class BeforeAfterTabs extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('[data-tab]');
        this.panes = this.querySelectorAll('[data-pane]');
        this.textPanels = this.querySelectorAll('[data-text]');
    }

    connectedCallback() {
        if (!this.tabs.length) return;

        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const id = tab.dataset.tab;
                this.setActiveTab(id);
            });
        });
    }

    setActiveTab(id) {
        this.tabs.forEach((tab) => {
            const isActive = tab.dataset.tab === id;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panes.forEach((pane) => {
            pane.classList.toggle('is-active', pane.dataset.pane === id);
        });

        this.textPanels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.text === id);
        });
    }
}

if (!customElements.get('before-after-tabs')) {
    customElements.define('before-after-tabs', BeforeAfterTabs);
}